import React from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';

const PaymentForm = ({ paymentMethod, formData, onInputChange, errors }) => {
  const handleInputChange = (field, value) => {
    onInputChange(field, value);
  };

  if (paymentMethod === 'card') {
    return (
      <div className="space-y-4 mb-6">
        <Input
          label="Cardholder Name"
          type="text"
          placeholder="Ola Nordmann"
          value={formData?.cardholderName}
          onChange={(e) => handleInputChange('cardholderName', e?.target?.value)}
          error={errors?.cardholderName}
          required
        />
        <Input
          label="Card Number"
          type="text"
          placeholder="1234 5678 9012 3456"
          value={formData?.cardNumber}
          onChange={(e) => handleInputChange('cardNumber', e?.target?.value)}
          error={errors?.cardNumber}
          required
        />
        <div className="grid grid-cols-2 gap-4">
          <Input
            label="Expiry Date"
            type="text"
            placeholder="MM/YY"
            value={formData?.expiryDate}
            onChange={(e) => handleInputChange('expiryDate', e?.target?.value)}
            error={errors?.expiryDate}
            required
          />
          
          <Input
            label="CVV"
            type="text"
            placeholder="123"
            value={formData?.cvv}
            onChange={(e) => handleInputChange('cvv', e?.target?.value)}
            error={errors?.cvv}
            required
          />
        </div>
        <Input
          label="Email Address"
          type="email"
          placeholder="ola@company.no"
          description="For payment confirmation and receipt"
          value={formData?.email}
          onChange={(e) => handleInputChange('email', e?.target?.value)}
          error={errors?.email}
          required
        />
      </div>
    );
  }

  if (paymentMethod === 'vipps') {
    return (
      <div className="bg-muted/30 rounded-xl p-6 mb-6 text-center">
        <Icon name="Smartphone" size={48} className="mx-auto mb-4 text-primary" />
        <h4 className="font-medium text-foreground mb-2">Pay with Vipps</h4>
        <p className="text-sm text-muted-foreground mb-4">
          You will be redirected to Vipps to complete your payment securely
        </p>
        <div className="bg-primary/10 rounded-lg p-3">
          <div className="text-sm font-medium text-primary">Amount: 149 kr</div>
        </div>
      </div>
    );
  }

  if (paymentMethod === 'paypal') {
    return (
      <div className="bg-muted/30 rounded-xl p-6 mb-6 text-center">
        <Icon name="Wallet" size={48} className="mx-auto mb-4 text-primary" />
        <h4 className="font-medium text-foreground mb-2">Pay with PayPal</h4>
        <p className="text-sm text-muted-foreground mb-4">
          You will be redirected to PayPal to complete your payment
        </p>
        <div className="bg-primary/10 rounded-lg p-3">
          <div className="text-sm font-medium text-primary">Amount: 149 kr</div>
        </div>
      </div>
    );
  }

  if (paymentMethod === 'klarna') {
    return (
      <div className="bg-muted/30 rounded-xl p-6 mb-6 text-center">
        <Icon name="Building2" size={48} className="mx-auto mb-4 text-primary" />
        <h4 className="font-medium text-foreground mb-2">Pay with Klarna</h4>
        <p className="text-sm text-muted-foreground mb-4">
          Buy now, pay later in 30 days or split into installments
        </p>
        <div className="bg-primary/10 rounded-lg p-3">
          <div className="text-sm font-medium text-primary">Amount: 149 kr</div>
        </div>
      </div>
    );
  }

  return null;
};

export default PaymentForm;